import $ from 'jquery';

let activeStateRelease = {
  initialize: function () {
    $('[data-active-state-release]')
      .on('touchstart', function () {
        let $anchor = $(this);
        $anchor.attr('data-active-state-release', 'touchstarted');
      })
      .on('click', function (event) {
        event.preventDefault();
        let $anchor = $(this);
        let link = $anchor.attr('href');

        let release = function (delay) {
          $anchor.attr('data-active-state-release', 'released');
          setTimeout(function () {
            $anchor.attr('data-active-state-release', '');
          }, 5000)
          setTimeout(function () {
            window.location.href = link;
          }, delay);
        };

        if ($anchor.attr('data-active-state-release') === 'touchstarted') {
          setTimeout(function () {
            release(750);
          }, 250);
        } else {
          release(750);
        }
      });
  }
};

activeStateRelease.initialize();
